import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { push } from 'react-router-redux';
import Divider from 'material-ui/Divider/Divider';
import { get, find } from 'lodash';

import { fetchProfileIfNeeded } from 'actions/profile';
import KFlatButton from 'components/KJRN/KFlatButton';
import ListItem from 'components/KJRN/KListItem';
import styles from 'styles/TProfile';
import TMessage from './TMessage';
import TLoading from './TLoading';
import KTitle from '../../components/KJRN/KTitle';
import KAvatar from '../../components/KJRN/KAvatar';

const TProfile = () => {
  const dispatch = useDispatch();
  const {
    employeeMasterLoaded, employeeDetailOrgListLoaded, detailError,
    masterError, employeeDetailOrgList, employeeMaster,
  } = useSelector(state => state.profileReducer);
  const {
    valuesByKey,
  } = useSelector(state => state.WebValuesReducer);

  useEffect(() => {
    dispatch(fetchProfileIfNeeded());
  }, []);

  if (!(employeeMasterLoaded && employeeDetailOrgListLoaded)) {
    return <TLoading />;
  }

  if (detailError || masterError) {
    return <TMessage type="error" message="tile.profile.error" />;
  }

  const employeeDetailOrg = find(employeeDetailOrgList, d => d.EmployeeDetailID === employeeMaster.DefaultEmployeeDetailID);

  const show = key => get(valuesByKey, [`Hide.${key}`, 'Value']) !== 'true';

  const search = (val) => {
    dispatch(push(`/search?query=${val}`));
  };

  const getText = key => get(employeeDetailOrg, key, '');

  return (
    <div style={styles.container}>
      <div style={styles.head}>
        <KAvatar
          imgSrc={employeeMaster.ImageUrl}
          masterId={employeeMaster.EmployeeMasterID}
          size={50}
          dataCy="EmployeeMaster.ImageUrl"
        />
        <KTitle
          title={employeeMaster.EmployeeName}
          style={styles.title}
          dataCy="EmployeeMaster.EmployeeName"
        />
      </div>
      <div style={styles.listContainer}>
        {show('EmployeeDetailOrg.OrgCompanyPositionName') && <ListItem
          primaryText={getText('OrgCompanyPositionName')}
          secondaryText={<div><FormattedMessage id="tile.profile.position" /></div>}
          data-cy="EmployeeDetailOrg.OrgCompanyPositionName"
          onClick={() => search(getText('OrgCompanyPositionName'))}
        />}
        {show('EmployeeDetailOrg.OrgCompanyUnitName') && <ListItem
          primaryText={getText('OrgCompanyUnitName')}
          secondaryText={<div><FormattedMessage id="tile.profile.unit" /></div>}
          data-cy="EmployeeDetailOrg.OrgCompanyUnitName"
          onClick={() => search(getText('OrgCompanyUnitName'))}
        />}
        {show('EmployeeDetailOrg.OrgCompanyUnitDivisionName') && <ListItem
          primaryText={getText('OrgCompanyUnitDivisionName')}
          secondaryText={<div><FormattedMessage id="tile.profile.division" /></div>}
          data-cy="EmployeeDetailOrg.OrgCompanyUnitDivisionName"
          onClick={() => search(getText('OrgCompanyUnitDivisionName'))}
        />}
        {show('EmployeeDetailOrg.ManagerName') && get(employeeDetailOrg, 'ManagerName', '') && <ListItem
          primaryText={getText('ManagerName')}
          secondaryText={<div><FormattedMessage id="tile.profile.manager" /></div>}
          data-cy="EmployeeDetailOrg.ManagerName"
          onClick={() => search(getText('ManagerName'))}
        />}
      </div>
      <Divider key="div" />
      <KFlatButton
        style={styles.actionButton}
        onClick={() => dispatch(push('/me'))}
        containerStyle={styles.action}
        label={<FormattedMessage id="tile.profile.goto" />}
      />
    </div>
  );
};

export default TProfile;



// WEBPACK FOOTER //
// ./src/containers/tiles/TProfile.js